export const FORM_DEFAULT_VALUES = {
  features: [],
  goals: '',
};

export const FEATURES = 'features';
export const TEXTAREA_MAX_LENGTH = 1024;
